var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIconAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9333 19.6453C18.4061 20.1181 19.1727 20.1181 19.6455 19.6453C20.1183 19.1725 20.1183 18.4059 19.6455 17.9331L11.7123 9.99992L19.6453 2.06689C20.1181 1.59409 20.1181 0.82751 19.6453 0.354701C19.1725 -0.118108 18.4059 -0.118108 17.9331 0.354701L10.0001 8.28773L2.06697 0.354607C1.59417 -0.118202 0.82759 -0.118202 0.354781 0.354607C-0.118028 0.827416 -0.118027 1.59399 0.354781 2.0668L8.2879 9.99992L0.354607 17.9332C-0.118202 18.406 -0.118202 19.1726 0.354607 19.6454C0.827416 20.1182 1.59399 20.1182 2.0668 19.6454L10.0001 11.7121L17.9333 19.6453Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconAlt);
export default __webpack_public_path__ + "static/media/close-icon-alt.b804626e.svg";
export { ForwardRef as ReactComponent };